module.exports = __webpack_public_path__ + "media/images/logo-footer@3x-797b51310620acee04e2fd353632fd33.png";